module.exports = __webpack_public_path__ + "img/img_review_thumb02.cef704c3.png";